<template>
  <div>
    <b-sidebar
      :width="width + 'px'"
      :id="id"
      :title="title"
      :right="right"
      :left="left"
      shadow
      backdrop
      @change="onChange"
    >
      <div class="px-3 py-2">
        <slot />
      </div>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  props: {
    onChange: {
      type: Function,
      default: () => {},
    },
    width: {
      type: Number,
      default: 250,
    },
    id: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    shadow: Boolean,
    right: Boolean,
    left: Boolean,
  },
};
</script>
9
